export default class RecoveryAgent {
  public firstName?: string;
  public lastName?: string;
  public email?: string;
  public phone?: string;

  constructor(obj: any) {
    this.firstName = obj?.firstName;
    this.lastName = obj?.lastName;
    this.email = obj?.email;
    this.phone = obj?.phone;
  }
}
